export const customerMenu = (organisationRouterLink: string) => {
  return [
    { label: 'Home', icon: 'home', routerLink: ['/app'] },
    {
      label: 'Create New Order',
      icon: '',
      routerLink: ['/app/job/create/1'],
      //items:
      //[
      //{label: "Driven", icon: "", routerLink: ["/app/job/create/1"]},
      //{label: "Transported", icon: "", routerLink: ["/app/job/create/2"]},
      //{label: "Recovery", icon: "", routerLink: ["/app/job/create/3"]},
      //]
    },
    { label: 'Listed Orders', icon: '', routerLink: ['/app/customerinbox'] },
    { label: 'Vehicle LifeCycle', icon: '', routerLink: ['/app/vehiclelifecycle'] },
    { label: 'Upload Orders', icon: '', routerLink: ['/app/order/upload'] },
    {
      label: 'Administration',
      icon: '',
      items: [
        {
          label: 'Driver Checklist',
          icon: '',
          routerLink: ['/app/customers/driverchecklistcustomer'],
        },
        { label: 'Job Tags', icon: '', routerLink: ['/app/jobtagscustomer'] },
        { label: 'Customer Sites', icon: '', routerLink: ['/app/customer-sites'] },
        // {label: "Engineius Agreement", icon: "", routerLink: ["/app/agreementcustomer"]},
        //{label: "User Notifications", icon: "", routerLink: ["/app"]},
      ],
    },
    {
      label: 'Manage Account ',
      icon: '',
      items: [
        { label: 'Users', icon: '', routerLink: ['/app/customerusers'] },
        {
          label: 'Organisation Structure',
          icon: '',
          routerLink: ['/app/orgstructurecustomer'],
        },
        { label: 'Organisation', icon: '', routerLink: [organisationRouterLink] },
        { label: 'Mandatory Photo Mapping', icon: '', routerLink: ['/app/customer-photos'] },
        { label: 'Invoice Addresses', icon: '', routerLink: ['/app/invoiceaddresses'] },
        //{label: "Preferred Suppliers", icon: "", routerLink: ["/app/preferredsuppliers"]},
      ],
    },
    {
      label: 'Billing & Payment ',
      icon: '',
      items: [
        { label: 'Invoices', icon: '', routerLink: ['/app/customerinvoices'] },
        // {label: "Payment Details", icon: "", routerLink: ["/app"]},
        { label: 'Cost Codes', icon: '', routerLink: ['/app/accountcodescustomer'] },
      ],
    },
    {
      label: 'Reporting ',
      icon: '',
      items: [
        { label: 'Orders', icon: '', routerLink: ['/app/report/orders'] },
        { label: 'Orders Beta', icon: '', routerLink: ['/app/report/ordersbeta'] },
      ],
    },
    { label: 'Customer Agreement', icon: '', routerLink: ['/app/termsconditions/view'] },
    {
      label: 'Help',
      icon: '',
      url: 'https://www.engineius.co.uk/customer-guides-new',
      target: '_blank',
    },
  ];
};
